import { useDraggable } from "@dnd-kit/core";

const Draggable = ({ item }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: item.id,
    // data: item,
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        cursor: "grab",
        userSelect: "none",
        padding: "0px 10px",
      }}
    >
      <div
        className="d-flex align-items-center gap-2 my-2 "
        style={{
          borderRadius: 5,
          background: "#f8fafc",
          border: "1px solid #e5e7eb",
          padding: "0px 12px",
        }}
      >
        {/* Icon */}
        <div style={{ fontSize: 20, marginBottom: 5 }}>{item.icon}</div>

        {/* Title */}
        <div
          style={{
            fontSize: 13,
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
          }}
          title={item.title}
        >
          {item.title}
        </div>
      </div>
    </div>
  );
};

export default Draggable;
